import { styled } from '@mui/material/styles';
import { Box, Paper, Tabs, Divider } from '@mui/material';

// ============================================
// Page Layout
// ============================================

export const PageContainer = styled(Paper)({
  background: '#fff',
  borderRadius: '10px',
  width: '100%',
});

export const TabsHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '10px',
});

// ============================================
// Tabs
// ============================================
// 비활성 탭: 흰 배경 + teal 1px 테두리, 활성 탭: teal 배경 + 흰 글씨.
// MUI 자동 생성 emotion 클래스(예: .css-heg063-...) 의존을 제거하기 위해 표준 셀렉터만 사용한다.
export const StyledTabs = styled(Tabs)({
  '& .MuiTab-root.MuiTab-textColorSecondary': {
    borderRadius: '12px',
    marginRight: '10px',
    minWidth: '100px',
    minHeight: '40px !important',
    padding: '12px 26px',
    fontWeight: 700,
    fontSize: '15px',
    border: '1px solid #ddd',
    color: '#666',
  },
  '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
    background: '#4AB3BC',
    borderRadius: '12px',
    border: 'none',
    color: '#fff',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    overflowX: 'auto',
  },
});

export const PageDivider = styled(Divider)({
  color: '#e1e1e1',
});
